export default __webpack_public_path__ + "img/fb95bf85148246abe2c65241febe61f2.png";